import axiosInstance from "../../axios/axios";

export const AccountVerificationApi = async (credential) =>
  await axiosInstance.post(`/vozo/provider/accountverify`, credential);

export const TemporaryResApi = async (credential) =>
  await axiosInstance.post(`/vozo/provider/tempres`, credential);
